export const selectUserAbsences = (state) => state.absence.absences